import { useState } from "react";
import { playNote } from "@/lib/audio";

// 2 octave keyboard starting at C3
const WHITE = ["C", "D", "E", "F", "G", "A", "B"];
const BLACK_MAP = { 0: "C#", 1: "D#", 3: "F#", 4: "G#", 5: "A#" };

export default function Keyboard({ preset, octaves = 2, baseOctave = 3 }) {
  const [active, setActive] = useState(null);

  const noteToMidi = (n, oct) => {
    const map = { C: 0, "C#": 1, D: 2, "D#": 3, E: 4, F: 5, "F#": 6, G: 7, "G#": 8, A: 9, "A#": 10, B: 11 };
    return 12 * (oct + 1) + map[n];
  };

  const trigger = (note, oct) => {
    if (!preset) return;
    const midi = noteToMidi(note, oct);
    setActive(`${note}${oct}`);
    playNote(preset, midi, 0.45);
    setTimeout(() => setActive(null), 220);
  };

  const whites = [];
  for (let o = 0; o < octaves; o++) {
    const oct = baseOctave + o;
    WHITE.forEach((n, idx) => {
      whites.push({ note: n, oct, idx });
    });
  }

  return (
    <div className="relative select-none" data-testid="synth-keyboard">
      <div className="flex">
        {whites.map(({ note, oct }, i) => {
          const id = `${note}${oct}`;
          return (
            <button
              key={id}
              onMouseDown={() => trigger(note, oct)}
              onTouchStart={() => trigger(note, oct)}
              data-testid={`key-white-${id}`}
              className={`piano-key-white h-32 w-10 sm:w-12 -ml-px first:ml-0 flex items-end justify-center pb-2 text-[9px] tracking-[0.2em] uppercase text-ink-dim hover:text-white transition-colors ${active === id ? "active" : ""}`}
            >
              {note}
              <span className="text-ink-dim/60 ml-1">{oct}</span>
            </button>
          );
        })}
      </div>
      {/* Black keys overlay */}
      <div className="absolute top-0 left-0 right-0 pointer-events-none">
        <div className="flex">
          {whites.map(({ note, oct, idx }, i) => {
            const black = BLACK_MAP[idx];
            const id = black ? `${black}${oct}` : null;
            return (
              <div key={`b-${i}`} className="w-10 sm:w-12 h-20 relative">
                {black && (
                  <button
                    onMouseDown={() => trigger(black, oct)}
                    onTouchStart={() => trigger(black, oct)}
                    data-testid={`key-black-${id}`}
                    className={`piano-key-black absolute -right-3 sm:-right-3.5 top-0 h-20 w-6 sm:w-7 pointer-events-auto ${active === id ? "active" : ""}`}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
